import { store } from 'redux/store';
import { getDocument } from 'modules/documents/redux/documentActions';

export default async function getScriptureDocument(documnetId: string) {
  const document = await store.dispatch(getDocument(documnetId));
  return document;
}
